import ReportEditConfigController from '../ReportEditConfigController'
import {ReportGroupingLevel} from '../../constants'
import LeavesGroupingSelector from '../../LeavesGroupingSelector'
import messageResource from '../../../messageResource'
import {LeaveTypeColumnConfig} from '../../leavesReport/LeaveReportConfig'
import LeaveReportColumnsFormatSelector from '../../../controls/LeaveReportColumnsFormatSelector'
import $ from 'jquery'
import LeaveTypesSelectorButton from '../../../controls/LeaveTypesSelectorButton'
import {formatLFM} from '../../../util/UserNameFormat'

export default class LeavesReportEditConfigController extends ReportEditConfigController {}

LeavesReportEditConfigController.prototype.init = function ( config )
{
    ReportEditConfigController.prototype.init.call(this, config);

    const self = this;
    const reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters);
    this.reportAuthorizationInfo = config.reportAuthorizationInfo

    this.configChangedCallback = config.changeCallback;
    const configChanged = function () { self.configChanged(); };
    this.timeFormatSelector = this.initTimeFormatSelector( reportParameters.timeFormat, configChanged);

    const groupingLevelsSelection = [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel];
    this.groupingSelector = new LeavesGroupingSelector().init(
        "reportGroupingSelector",
        groupingLevelsSelection,
        this.productSettingsValidator.isUGREnabled() || this.checkGroupingLevel(ReportGroupingLevel.USER_GROUP, groupingLevelsSelection),
        this.productSettingsValidator.isTZGEnabled() || this.checkGroupingLevel(ReportGroupingLevel.TIME_ZONE_GROUP, groupingLevelsSelection),
        function() {
            self.removeGroupingLevelsSelectionError();
            configChanged();
        });

    this.initLeavesSelector(reportParameters.leaveTypeSelection, config.leavesData, configChanged);

    // if feature enabled and user has rights otherwise only if data is not "LeaveTimeOnly" - show selector
    this.columnsDisplayFormat = this.addColumnFormatFilter(
        {
            columnsConfig: reportParameters.columnsConfig,
            balanceQualifier: reportParameters.balanceQualifier,
            onChangeCallback: configChanged,
            reportAuthorizationInfo: config.reportAuthorizationInfo,
        }
    )

    config.additionalCheckboxLabel = messageResource.getMessage("users_selector.reports.include_users_wo_data");

    const $usernameLabel = $('.usernameLabel')
    $usernameLabel.toggle(!this.reportAuthorizationInfo.anyOtherUsersAvailable)

    if (this.reportAuthorizationInfo.anyOtherUsersAvailable) {
        this.userSelector = this.makeUserSelector({
            ...config,
            allUsersAvailable: this.reportAuthorizationInfo.allUsersAvailable
        });
    } else {
        $('#userSelectorId').hide()
        const user = config.users[0]
        const usernameFormatted = formatLFM(user.firstName, user.lastName, user.middleName, ", ")
        $usernameLabel.text(usernameFormatted)
    }

    return this;
};

/**
 * add column format filter if need
 * @param columnsConfig - leave tyime only or balance + leave time or both
 * @param balanceQualifier - for type of balance sdb or pto or both
 * @param onChangeCallback
 * @param reportAuthorizationInfo - LeavesReportAuthorizationInfo
 * @returns {{getValue, setActiveItemByValue}}
 */
LeavesReportEditConfigController.prototype.addColumnFormatFilter = function({columnsConfig, balanceQualifier, onChangeCallback, reportAuthorizationInfo}) {

    const enabledPTO =  this.productSettingsValidator.isPTOEnabled()
                        && reportAuthorizationInfo.ptoBalancesAvailable
    const enabledSick =  this.productSettingsValidator.isSickEnabled()
                         && reportAuthorizationInfo.sickDaysBalancesAvailable

    const ifNeedColumnFormatSelector = enabledPTO || enabledSick
    const selectorRow = $("#columnsFormatFilterRow");

    if (ifNeedColumnFormatSelector) {
        const initValue = {
            columnsConfig: columnsConfig,
            balanceQualifier: balanceQualifier
        }
        selectorRow.show();
        return new LeaveReportColumnsFormatSelector().init("columnsDisplayFormat", initValue, onChangeCallback, enabledPTO, enabledSick);
    } else {
        const initValue = {
            columnsConfig: LeaveTypeColumnConfig.LEAVE_TIME_ONLY,
            balanceQualifier: balanceQualifier
        }
        selectorRow.hide();
        return this.initEmptyListSelector(initValue);
    }
};

LeavesReportEditConfigController.prototype.initLeavesSelector = function ( leavesSelection, leavesData, changeCallback )
{
    const self = this;
    const leavesSelectorChangesCallback = function()
    {
        if ( !self.leavesSelector.isEmptySelection() )
            self.errors.remove(self.possibleErrors.ERROR_EMPTY_LEAVE_TYPES_SELECTION);
        self.updateUI();
        if ( changeCallback )
            changeCallback();
    };
    this.leavesSelector = new LeaveTypesSelectorButton().init({
            renderTo: "leavesButton",
            leavesSelection,
            leavesData,
            ptoFeatureEnabled: this.productSettingsValidator.isPTOEnabled(),
            sickBalanceFeatureEnabled: this.productSettingsValidator.isSickEnabled(),
            changeCallback: leavesSelectorChangesCallback
        }
    )
};

LeavesReportEditConfigController.prototype.getConfig = function () {
    const groupingLevelValues = this.groupingSelector.getValues();
    const columnsDisplayFormatValue = this.columnsDisplayFormat.getValue();
    return {
        timeFormat: this.timeFormatSelector.getValue(),
        leaveTypeSelection : this.leavesSelector.getLeaveTypeSelection(),
        columnsConfig: columnsDisplayFormatValue.columnsConfig,
        balanceQualifier: columnsDisplayFormatValue.balanceQualifier,
        userSelection: this.reportAuthorizationInfo.anyOtherUsersAvailable ? this.userSelector.getSelection() : this.initReportParameters.userSelection,
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1]
    };
};

LeavesReportEditConfigController.prototype.resetConfig = function () {
    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);
    this.columnsDisplayFormat.setActiveItemByValue(
        {
            columnsConfig : this.initReportParameters.columnsConfig,
            balanceQualifier : this.initReportParameters.balanceQualifier
        },
        true
    );
    this.groupingSelector.setValues([this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel]);
    this.leavesSelector.resetLeavesSelectionFunction();

    if (this.reportAuthorizationInfo.anyOtherUsersAvailable)
        this.userSelector.setSelection(this.initReportParameters.userSelection);
};

LeavesReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    ReportEditConfigController.prototype.setSelectorsInitStateFromCurrent.call(this);

    if(this.reportAuthorizationInfo.anyOtherUsersAvailable){
        this.userSelector.setInitialValueFromCurrent();
    }
    if(this.leavesSelector){
        this.leavesSelector.setInitialValuesFromCurrent ();
    }
};

LeavesReportEditConfigController.prototype.validate = function ()
{
    this.errors = [];

    if (this.leavesSelector.isEmptySelection())
        this.errors.push(this.possibleErrors.ERROR_EMPTY_LEAVE_TYPES_SELECTION);

    if (this.reportAuthorizationInfo.anyOtherUsersAvailable && !this.userSelector.validateIsUserSelected())
        this.errors.push( this.possibleErrors.ERROR_EMPTY_USER_SELECTION );

    if (!this.groupingSelector.validate())
        this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length === 0;
};

LeavesReportEditConfigController.prototype.initErrorsToSectionElsMap = function()
{
    const errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_USER_SELECTION] = this.panelEl.find( "#userSelectorId" );
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_LEAVE_TYPES_SELECTION] = this.panelEl.find( "#leavesButton" );
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find( ".reportGroupingSelectorContainer" );
    return errorsToSectionElsMap;
};

LeavesReportEditConfigController.prototype.makeReportParamsAccordingToFeatures = function ( reportParameters ) {
    return reportParameters;
};


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/leaves/LeavesReportEditConfigController.js